import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  documents: {
    'sifa.inspection-report': () => import('./documents/inspection-report'),
  },
  pages: [
    {
      path: '/sifa/inspections',
      load: () => import('./inspections-page'),
      permission: 'sifa.inspection.read',
    },
    {
      path: '/sifa/inspections/$id',
      load: () => import('./inspection-page'),
      permission: 'sifa.inspection.read',
    },
    {
      path: '/sifa/substances',
      load: () => import('./substances-page'),
      permission: 'sifa.substance.search',
    },
  ],
  recordSections: [
    {
      key: 'sifa.project-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ProjectInspectionsSection })),
    },
    {
      key: 'sifa.object-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ObjectInspectionsSection })),
    },
  ],
  guides: [
    {
      id: 'sifa.inspections',
      title: 'sifa.guides.inspections.title',
      summary: 'sifa.guides.inspections.summary',
      pages: ['/sifa/inspections', '/sifa/inspections/$id'],
      content: {
        de: () => import('./guides/inspections.de.md?raw'),
        en: () => import('./guides/inspections.en.md?raw'),
      },
    },
    {
      id: 'sifa.substances',
      title: 'sifa.guides.substances.title',
      summary: 'sifa.guides.substances.summary',
      permission: 'sifa.substance.search',
      pages: ['/sifa/substances'],
      content: {
        de: () => import('./guides/substances.de.md?raw'),
        en: () => import('./guides/substances.en.md?raw'),
      },
    },
  ],
});
